import { Inject, Injectable } from "@angular/core";
import {
  Auth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  User,
} from "@angular/fire/auth";
import { Router } from "@angular/router";
import { BehaviorSubject, Observable } from "rxjs";
import { UserAdminService } from "./user-admin.service";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private userSubject: BehaviorSubject<User | null> =
    new BehaviorSubject<User | null>(null);
  public user$: Observable<User | null> = this.userSubject.asObservable();

  constructor(
    private afAuth: Auth,
    @Inject(UserAdminService) private userAdminService: UserAdminService,
    @Inject(Router) private router: Router
  ) {
    onAuthStateChanged(this.afAuth, (user) => {
      if (user) {
        localStorage.setItem("user", JSON.stringify(user));
        this.userSubject.next(user);
      } else {
        localStorage.clear();
        this.userSubject.next(null);
      }
    });
  }

  async login(user: { email: string; password: string }) {
    const auth = await signInWithEmailAndPassword(
      this.afAuth,
      user.email.trim().toLowerCase(),
      user.password
    );

    const adminRecord = await this.userAdminService.getByUid(auth.user!.uid);
    if (!adminRecord || adminRecord.ativo === false) {
      await this.afAuth.signOut();
      localStorage.clear();
      throw Object.assign(
        new Error(
          adminRecord?.ativo === false
            ? "Usuário administrador desativado."
            : "Sem permissão de administrador."
        ),
        {
          code:
            adminRecord?.ativo === false
              ? "admin/disabled"
              : "admin/not-found",
        }
      );
    }

    localStorage.setItem("user_admin", JSON.stringify(adminRecord));
    this.router.navigate(["/dashboard"]);
    return adminRecord;
  }

  /** Confirma se o usuário autenticado ainda é admin ativo. */
  async ensureAdminAccess(): Promise<boolean> {
    const current = this.afAuth.currentUser;
    if (!current) {
      return false;
    }
    const adminRecord = await this.userAdminService.getByUid(current.uid);
    if (!adminRecord || adminRecord.ativo === false) {
      await this.logout();
      return false;
    }
    localStorage.setItem("user_admin", JSON.stringify(adminRecord));
    return true;
  }

  getAuth() {
    return this.afAuth;
  }

  async logout() {
    localStorage.removeItem("_cnpj");
    localStorage.removeItem("_companyId");
    localStorage.removeItem("user");
    localStorage.removeItem("user_admin");
    await this.afAuth.signOut();
    this.userSubject.next(null);
  }
}
